import { SSRGlobal } from "./Context"
export default (props) => {
    
    let z = SSRGlobal()
    return <div style={{}} id={props.name + "_detail_" + props.id} 
    className={props.open ? z.styles.openheight : z.styles.closeheight}>
        {props.open ? props.children : null}
    </div>
}